import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";

interface InfoAnimalTransferProps {
  task: ITaskAnimalTransfer | undefined;
}


export default function InfoAnimalTransfer(task: InfoAnimalTransferProps) {
  useTranslation();
  const [taskAnimalTransfer, setTaskAnimalTransfer] = useState<ITaskAnimalTransfer>();
  useEffect(() => {
    setTaskAnimalTransfer(task.task)
  }, []);

  const mapText = new Map();
  mapText.set("RETIRO", "Retiro")
  mapText.set("FAZENDA", "Fazenda")

  return (
    <>
      <div >
        <span><Trans i18nKey="taskDetails.fromBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskAnimalTransfer?.batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`Qual o tipo de transferência?`} pointed />
        <ButtonPressed onlyResult optionSelected={1} value={1} text={`${mapText.get(taskAnimalTransfer?.transfer_type)}`} />
      </div>

      <div>
        <span><Trans i18nKey="taskDetails.toArea" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AreaIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskAnimalTransfer?.destination_area_full_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      {taskAnimalTransfer?.categories.filter(category => category.task_type === "Início de Transferência")
        .map((category, index) => (
          <div key={index}>
            <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(category.category_description.name, category.category_description.age_description)}</div>
            <div className="lot__subtitle--category">{translateAnimalCategoryAge(category.category_description.age_description, category.category_description.name)}</div>
            <CounterInputV2 name={`info-animal-transfer-qty-${index}`} value={Number(category.quantity ?? 0)} disabled />
          </div>
        ))}
    </>
  )
}
